import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK, serverUrl } from "@globalConfig";
import { api__createTabbyRemainingCheckout, api__tabbyPreScoringRemaining } from "@/apis/tabby/tabbyRemainingPayment";
import { api__createAmwalRemainingCheckout } from "@/apis/amwal/amwalRemainingPayment";
import { api__createTamaraRemainingCheckout } from "@/apis/tamara/tamaraRemainingPayment";
import { toast } from "sonner";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import Markdown from "markdown-to-jsx";
import { useLang } from "@/common/Contexts/LanguageContext";
var BnplRemainingSection = function BnplRemainingSection(_ref) {
  var isFinance = _ref.isFinance,
    order = _ref.order,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab,
    option = _ref.option;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState(null),
    tabbyEligible = _useState2[0],
    setTabbyEligible = _useState2[1];
  var _useState3 = useState(null),
    tabbyRejectionMessage = _useState3[0],
    setTabbyRejectionMessage = _useState3[1];
  var tabKey = "bnpl_remaining_".concat(option.type);
  var _useSession = useSession(),
    user = _useSession.user;
  var lang = useLang();
  useEffect(function () {
    if (option.type !== "tabby" || !(order !== null && order !== void 0 && order.order_uuid)) return;
    api__tabbyPreScoringRemaining({
      order_uuid: order.order_uuid
    }).then(function (res) {
      if (res.data.rejection_reason) {
        setTabbyEligible(false);
        setTabbyRejectionMessage(res.data.message);
      } else {
        setTabbyEligible(true);
      }
    })["catch"](function () {
      setTabbyEligible(true);
    });
  }, []);
  var buildCallbackParams = function buildCallbackParams(orderId) {
    var _order$g4_data_layer, _order$g4_data_layer2, _order$g4_data_layer3;
    var orderUuid = (order === null || order === void 0 ? void 0 : order.order_uuid) || "";
    var postId = (order === null || order === void 0 ? void 0 : order.post_id) || "";
    var inventoryType = (order === null || order === void 0 ? void 0 : (_order$g4_data_layer = order.g4_data_layer) === null || _order$g4_data_layer === void 0 ? void 0 : _order$g4_data_layer.inventory_type_string) || "";
    var postMake = (order === null || order === void 0 ? void 0 : (_order$g4_data_layer2 = order.g4_data_layer) === null || _order$g4_data_layer2 === void 0 ? void 0 : _order$g4_data_layer2.post_make) || "";
    var postCondition = (order === null || order === void 0 ? void 0 : (_order$g4_data_layer3 = order.g4_data_layer) === null || _order$g4_data_layer3 === void 0 ? void 0 : _order$g4_data_layer3.post_condition) || "";
    var totalAmount = isFinance ? (order === null || order === void 0 ? void 0 : order.total_amount) || "" : (order === null || order === void 0 ? void 0 : order.total_price) || "";
    var remainingAmountRaw = isFinance ? (order === null || order === void 0 ? void 0 : order.remaining_amount) || (order === null || order === void 0 ? void 0 : order.vas_amount) || "" : (order === null || order === void 0 ? void 0 : order.remaining_price_payed) || (order === null || order === void 0 ? void 0 : order.remaining_price) || "";
    var remainingAmount = parseInt(String(remainingAmountRaw).replace(/,/g, "")) || "";
    var returnTo = typeof window !== "undefined" ? window.location.href : "";
    return new URLSearchParams({
      order_id: String(orderId),
      is_finance: isFinance ? "1" : "0",
      order_uuid: orderUuid,
      post_id: String(postId),
      inventory_type: String(inventoryType),
      post_make: String(postMake),
      post_condition: String(postCondition),
      total_amount: String(totalAmount),
      remaining_amount: String(remainingAmount),
      return_to: returnTo
    }).toString();
  };
  var getTrackingData = function getTrackingData(orderId) {
    var _order$g4_data_layer4, _order$g4_data_layer5, _order$g4_data_layer6;
    return {
      post_id: (order === null || order === void 0 ? void 0 : order.post_id) || "",
      order_id: String(orderId),
      inventory_type: (order === null || order === void 0 ? void 0 : (_order$g4_data_layer4 = order.g4_data_layer) === null || _order$g4_data_layer4 === void 0 ? void 0 : _order$g4_data_layer4.inventory_type_string) || "",
      post_make: (order === null || order === void 0 ? void 0 : (_order$g4_data_layer5 = order.g4_data_layer) === null || _order$g4_data_layer5 === void 0 ? void 0 : _order$g4_data_layer5.post_make) || "",
      post_condition: (order === null || order === void 0 ? void 0 : (_order$g4_data_layer6 = order.g4_data_layer) === null || _order$g4_data_layer6 === void 0 ? void 0 : _order$g4_data_layer6.post_condition) || "",
      total_amount: isFinance ? (order === null || order === void 0 ? void 0 : order.total_amount) || "" : (order === null || order === void 0 ? void 0 : order.total_price) || "",
      remaining_amount: parseInt(String(isFinance ? (order === null || order === void 0 ? void 0 : order.remaining_amount) || (order === null || order === void 0 ? void 0 : order.vas_amount) || "" : (order === null || order === void 0 ? void 0 : order.remaining_price_payed) || (order === null || order === void 0 ? void 0 : order.remaining_price) || "").replace(/,/g, "")) || "",
      platform: getPlatformInfo(),
      referral_location: "remaining_payment"
    };
  };
  var handlePay = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var orderId, orderUuid, callbackParams, checkoutUrl, _response$data, response, _response$data2, _response, _response2$data, _response2, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            orderId = isFinance ? order === null || order === void 0 ? void 0 : order.order_id : order === null || order === void 0 ? void 0 : order.id;
            orderUuid = (order === null || order === void 0 ? void 0 : order.order_uuid) || "";
            if (!(!orderId || !orderUuid)) {
              _context.n = 1;
              break;
            }
            toast.error(tShort("tabby/payment_session_error", {
              ns: "web_common"
            }));
            return _context.a(2);
          case 1:
            _context.p = 1;
            setIsLoading(true);
            callbackParams = buildCallbackParams(orderId);
            if (!(option.type === "tabby")) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return api__createTabbyRemainingCheckout({
              order_uuid: orderUuid,
              success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tabby/payment-success?").concat(callbackParams),
              failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tabby/payment-failed?").concat(callbackParams),
              cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tabby/payment-cancel?").concat(callbackParams)
            });
          case 2:
            response = _context.v;
            if (response !== null && response !== void 0 && response.success && response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.checkout_url) {
              checkoutUrl = response.data.checkout_url;
              trackEvents("tabby_remaining_payment_initiated", getTrackingData(orderId));
            }
            _context.n = 7;
            break;
          case 3:
            if (!(option.type === "amwal")) {
              _context.n = 5;
              break;
            }
            _context.n = 4;
            return api__createAmwalRemainingCheckout({
              order_uuid: orderUuid,
              success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/amwal/payment-status?").concat(callbackParams),
              failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/amwal/payment-status?").concat(callbackParams),
              cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/amwal/payment-status?").concat(callbackParams)
            });
          case 4:
            _response = _context.v;
            if (_response !== null && _response !== void 0 && _response.success && _response !== null && _response !== void 0 && (_response$data2 = _response.data) !== null && _response$data2 !== void 0 && _response$data2.checkout_url) {
              checkoutUrl = _response.data.checkout_url;
              trackEvents("amwal_remaining_payment_initiated", getTrackingData(orderId));
            }
            _context.n = 7;
            break;
          case 5:
            if (!(option.type === "tamara")) {
              _context.n = 7;
              break;
            }
            _context.n = 6;
            return api__createTamaraRemainingCheckout({
              order_uuid: orderUuid,
              success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tamara/payment-success?").concat(callbackParams),
              failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tamara/payment-failed?").concat(callbackParams),
              cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "remaining-payment/tamara/payment-cancel?").concat(callbackParams)
            });
          case 6:
            _response2 = _context.v;
            if (_response2 !== null && _response2 !== void 0 && _response2.success && _response2 !== null && _response2 !== void 0 && (_response2$data = _response2.data) !== null && _response2$data !== void 0 && _response2$data.checkout_url) {
              checkoutUrl = _response2.data.checkout_url;
              trackEvents("tamara_remaining_payment_initiated", getTrackingData(orderId));
            }
          case 7:
            if (checkoutUrl) {
              window.location.href = checkoutUrl;
            } else {
              toast.error(tShort("tabby/payment_session_error", {
                ns: "web_common"
              }));
            }
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t = _context.v;
            console.error("Error creating ".concat(option.type, " remaining payment checkout:"), _t);
            toast.error(tShort("tabby/payment_session_error", {
              ns: "web_common"
            }));
          case 9:
            _context.p = 9;
            setIsLoading(false);
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[1, 8, 9, 10]]);
    }));
    return function handlePay() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("li", {
    className: ["flex flex-wrap justify-between items-center px-2 py-3 border border-gray-gainsboro rounded-lg relative mb-3 border-solid", activeTab === tabKey ? "border-[#0D0DB5]" : ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between cursor-pointer flex-[100%]",
    onClick: function onClick() {
      return setActiveTab(activeTab === tabKey ? -1 : tabKey);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: option.image_url,
    alt: option.type,
    width: option.type == 'amwal' ? 35 : 77,
    height: option.type == 'amwal' ? 30 : 26
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "text-xs text-[#B0B0B0] [&>strong]:font-bold gap-1 mr-auto ms-1 flex items-center"
  }, option.title), /*#__PURE__*/React.createElement("img", {
    className: "transition-transform duration-300 ".concat(activeTab === tabKey ? "rotate-180" : ""),
    src: CDN_LINK + "/assets/images/remaining-arrow.svg",
    alt: ""
  }))), activeTab === tabKey && /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-[#0D0DB5] text-white font-bold w-full h-12 rounded block mx-auto mt-6 mb-1 cursor-pointer border-none disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none",
    onClick: handlePay,
    disabled: isLoading || tabbyEligible === false
  }, isLoading ? /*#__PURE__*/React.createElement(FLowLoadingSpinner, null) : tShort("".concat(option.type, "/pay_now"), {
    ns: "web_common"
  })), tabbyRejectionMessage && /*#__PURE__*/React.createElement("p", {
    className: "text-xs text-red-500 mt-2"
  }, tabbyRejectionMessage)));
};
export default BnplRemainingSection;